import { eventBus } from '../event-bus';
import { t } from '../translations';
import { isBannerPage, updatePPAGInlineButton } from './banner-page-utils';
import { isDesignPage, updateDesignButtonState, hideDesignHelpButton } from './design-page-utils';
import { isHelpPanelAnywherePage, sendEventToHelpAnywherePanel } from './help-panel-utils';
import { isOrderHelpPage, isHelpCenterHomepage } from './page-utils';

export const onMaximize = () => {
  console.info('onMaximize');
  eventBus.dispatch('CAafterMaximize', {});

  /** Send Event to HP to hide Chat loading button and hide HP */
  if (isHelpPanelAnywherePage()) {
    document.addEventListener('helpPanelLoaded', () => {
      sendEventToHelpAnywherePanel('hideChatLoader');
      sendEventToHelpAnywherePanel('hideHelpPanel');
      sessionStorage.removeItem('CAUnreadMessage');
    });
    sendEventToHelpAnywherePanel('hideChatLoader');
    sendEventToHelpAnywherePanel('hideHelpPanel');
    sessionStorage.removeItem('CAUnreadMessage');
  }

  /** If chat is opened, disable the inline button */
  isBannerPage().then((result) => {
    if (result && result.allowed && result.matchedStyle) {
      updatePPAGInlineButton(t('chatting-text'), true, result.matchedStyle);
    }
  });

  if (isDesignPage()) {
    /** For Design Page, update the button state */
    updateDesignButtonState(t('chatting-text'), true);
  }
};

export const onMinimize = () => {
  console.info('onMinimize');
};
export const onChatReady = async (isChatEnabled: boolean) => {
  console.info('onChatReady');
  const isConversationBrowserClosed = sessionStorage.getItem('isConversationBrowserClosed');
  if (isConversationBrowserClosed) {
    sessionStorage.removeItem('isConversationBrowserClosed');
  }

  eventBus.dispatch('CAonChatInit', { isAgentAvailable: isChatEnabled });
  if (isHelpCenterHomepage()) {
    eventBus.on('helpCenterChatWidgetReady', () => {
      let count = 0;
      setInterval(() => {
        count += 1;
        eventBus.dispatch('CAonChatInit', { isAgentAvailable: isChatEnabled });
      }, 2000);
      if (count > 3) {
        clearInterval(count);
      }
    });
  }

  console.info('Chat Status on Ready', isChatEnabled);
  isBannerPage().then((result) => {
    if (result && result.allowed && result.matchedStyle) {
      updatePPAGInlineButton(t('start-chat'), !isChatEnabled, result.matchedStyle);
    }
  });

  if (isHelpPanelAnywherePage()) {
    sendEventToHelpAnywherePanel('hideChatScriptLoader');
  } else if (isDesignPage()) {
    const buttonText = t('ca-message');
    updateDesignButtonState(buttonText, !isChatEnabled);
    if (!isChatEnabled) {
      hideDesignHelpButton();
    }
    // hideFloatingButton();
  } else if (isOrderHelpPage()) {
    // hideFloatingButton();
  } else {
    /** To show once chat is closed */
    // showFloatingButton();
  }
};
export const onChatEnded = () => {
  console.info('onChatEnded');
};
export const onButtonClick = () => {
  console.info('onButtonClick');
};
export const onChatEstablished = () => {
  console.info('onChatEstablished');
  if (isHelpPanelAnywherePage()) {
    sendEventToHelpAnywherePanel('chatEstablished');
  }
};
export const onMessageSent = () => {
  console.info('onMessageSent');
};

export const onSessionContinuation = () => {
  console.info('onSessionContinuation');
  /** Send Event for any external project using this event */
  eventBus.dispatch('CAonSessionActive', {});
  if (isHelpCenterHomepage()) {
    eventBus.on('helpCenterChatWidgetReady', () => {
      eventBus.dispatch('CAonSessionActive', {});
    });
  }
  isBannerPage().then((result) => {
    if (result && result.allowed && result.matchedStyle) {
      updatePPAGInlineButton(t('chatting-text'), true, result.matchedStyle);
    }
  });

  if (isHelpPanelAnywherePage()) {
    /** For Help Panel Pages */
    sendEventToHelpAnywherePanel('hideHelpPanel');
    sendEventToHelpAnywherePanel('hideChatScriptLoader');
    sendEventToHelpAnywherePanel('hideChatLoader');

    /** if Chatbot loaded before HP */
    document.addEventListener('helpPanelLoaded', () => {
      eventBus.dispatch('CAonSessionActive', {});

      sendEventToHelpAnywherePanel('hideHelpPanel');
      sendEventToHelpAnywherePanel('hideChatScriptLoader');
      sendEventToHelpAnywherePanel('hideChatLoader');
    });

    // populateLiveDesignLink();
  } else if (isHelpCenterHomepage()) {
    /** For Help Center Homepage */
    /** in case the ca scripts are loaded before HC page, send the event after recieving event from HC */
    document.addEventListener('helpCenterCAEvent', () => {
      eventBus.dispatch('CAonSessionActive', {});
    });
  } else if (isDesignPage()) {
    /** Update for Design and Search Page */
    updateDesignButtonState(t('chatting-text'), true);
  }
};
export const onChatTransfer = () => {
  console.info('onChatTransfer');
};
export const onChatEndedByUser = () => {
  console.info('onChatEndedByUser');
};

export const onBackButtonClick = () => {
  sendEventToHelpAnywherePanel('showHelpPanel');
  //
};
